import React, { useEffect } from 'react';
import { CircularProgress } from '@mui/material';
import useSearchHooks, { MenuSearchResult } from './searchMenu-hooks';
import AuthInput from '../../AuthInput/authInput';
import { IMenuListItem } from '../../../../Interfaces/responseTypes';
import { useNoAuthHooks } from '../../../../Hooks/hooks';
import { NoResult } from '../../../../Assets/Icons';
import styles from './searchMenu.module.scss';
import useLanguagesHooks from '../../../Languages/setLanguage-hooks';
import { SearchIcon } from '../../../IconComponents';

export interface ISearchMenuProps {
  menu_list: IMenuListItem[];
  searchHandler: (result: MenuSearchResult) => void;
  onClose?: () => void;
  containerStyles?: string;
  onResultsChange?:(hasResults: boolean) => void;
};

const SearchMenu: React.FC<ISearchMenuProps> = ({ menu_list, searchHandler, onClose, containerStyles,onResultsChange }) => {
  const { baseURL } = useNoAuthHooks();
  const { t } = useLanguagesHooks();
  const {
    results,
    isLoading,
    searchValue,
    searchContainerRef,
    register,
    onClickResult,
    handleInputChange,
  } = useSearchHooks({ menu_list, searchHandler, onClose });

  useEffect(() => {
    if(onResultsChange){
      onResultsChange?.(results.length > 0 && searchValue !== '');
    }
  }, [results, searchValue]);



  return (
    <div className={`${styles.container} ${containerStyles}`} ref={searchContainerRef}>
      <AuthInput
        type="text"
        id="search"
        inputStyle={styles.inputStyle}
        register={register}
        registerName="search"
        onChange={handleInputChange}
        placeholder={t('Input_Labels.Search')}
        showTextError={false}
        inputBoxStyles={styles.inputBox}
      >
        <span className={styles.searchIcon}>
          <SearchIcon color='var(--icon-color)' />
        </span>
      </AuthInput>

      {(isLoading || results.length > 0) && searchValue && (
        <div className={styles.resultsPopper}>
          {isLoading ? (
            <div className={styles.loadingBox}>
              <CircularProgress sx={{ color: '#b00020' }} size="25px" />
            </div>
          ) : (
            <div className={styles.resultsBox}>
              {results.map((result, index) => (
                <div key={index} className={styles.resultItem} onClick={() => onClickResult(result)}>
                  <img
                    src={`${baseURL}${result.item_id ? result.item_image : result.category_image
                      }`}
                    alt="image.png"
                  />
                  <p>{result.item_name ?? result.category_name}</p>
                </div>
              ))}
            </div>
          )}
        </div>
      )}
      {!isLoading && results.length === 0 && searchValue && (
        <div className={styles.resultsPopper}>
          <div className={styles.loadingBox}>
            <img src={NoResult} alt='noResult.svg' />
            <p className={styles.noResults}>{t('No_Data.No_Search')}</p>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchMenu;
